import { render, staticRenderFns } from "./BasicBackgroundHeroSectionModule.vue?vue&type=template&id=4bf46e0c&"
import script from "./BasicBackgroundHeroSectionModule.vue?vue&type=script&lang=js&"
export * from "./BasicBackgroundHeroSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports